import { render, staticRenderFns } from "./editAnnouncement.vue?vue&type=template&id=1d479762&scoped=true"
import script from "./editAnnouncement.vue?vue&type=script&lang=js"
export * from "./editAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./editAnnouncement.vue?vue&type=style&index=0&id=1d479762&prod&lang=scss&scoped=true"
import style1 from "./editAnnouncement.vue?vue&type=style&index=1&id=1d479762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d479762",
  null
  
)

export default component.exports